import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { loginQuery } from "../strapi/queries";

import logo from "../assets/logo.png";
import "./LoginForm.css";


export default function LoginForm({ onLoginSuccess }) {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState(null);

  const navigate = useNavigate();
  const { login } = loginQuery();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    try {
      const result = await login(identifier, password);
      if (result && result.user) {
        onLoginSuccess(result.user);
      }
    } catch (err) {
      setErrorMsg("Login fehlgeschlagen");
    }
  };

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="login-logo" />
          <p></p>
        </div>{" "}
        <div className="p-fluid">
          <div className="p-field">
            <InputText
              id="identifier"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="E-Mail oder Benutzername"
              required
              className="p-inputtext-lg"
            />
          </div>

          <div className="p-field">
            <Password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Passwort"
              toggleMask
              feedback={false}
              required
            />
          </div>

          {errorMsg && <Message severity="error" text={errorMsg} />}
          <p></p>
          <Button
            label="Login"
            icon="pi pi-sign-in"
            type="submit"
            onClick={handleLogin}
            className="p-button-lg p-button-primary"
            block
          />
          <p></p>
          <Button
            label="Registrieren"
            icon="pi pi-user-plus"
            onClick={handleRegisterClick}
            className="p-button-lg p-button-secondary"
            block
          />
        </div>
      </div>
    </div>
  );
}
